(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SharedTimeBoardController', SharedTimeBoardController);

    SharedTimeBoardController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ServiceItemCustom', 'ServiceCategoryCustom', '$translate', '$localStorage', '$timeout'];

    function SharedTimeBoardController($scope, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, ServiceItemCustom, ServiceCategoryCustom, translate, $localStorage, $timeout) {
        var vm = this;
        vm.schedulerApi = {refresh: 'not set'};
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.categoryName = categoryName;
        vm.storeInDefaults = storeInDefaults;
        vm.getFromDefaults = getFromDefaults;
        vm.startRefreshTimer = startRefreshTimer;
        vm.accessLevel = 'READ';


        vm.getFromDefaults();
        vm.startRefreshTimer();

        //vm.serviceItems=ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function(list){
        //   if(list && list.length>0) {
        //
        //       vm.selectedId=list[0].id;
        //       updateSharedTimeBoard();
        //   }
        //
        //});
        vm.onServiceChanged = function () {
            vm.storeInDefaults();
            updateSharedTimeBoard();
        }

        function startRefreshTimer() {
            setInterval(function () {
                vm.updateSharedTimeBoard();
            }, 300000)


        }

        vm.updateSharedTimeBoard = updateSharedTimeBoard;

        function updateSharedTimeBoard() {
            var serviceList = [];
            serviceList.push(vm.selectedId);
            TimingInfo.getTimingInfoByServiceItems.save({serviceItemIds: serviceList}, function (t) {
                vm.timingInfo = t;

            })
        }

        function storeInDefaults() {
            //console.log('storing in storage :'+vm.selectedId)
            //if(vm.selectedId!=undefined)
            //$localStorage.selectedId=vm.selectedId;
        }

        function getFromDefaults() {
            //console.log('reading from storage :'+vm.selectedId)
            //if($localStorage.selectedId!=undefined)
            //{
            //
            //    var serviceList=[];
            //    vm.selectedId=$localStorage.selectedId;
            //    console.log('exista storage :'+vm.selectedId)
            //}
        }
    }
})();
